export default __webpack_public_path__ + "static/media/2.6553bc3f.jpg";